<template>
	<div class="footer">
		<div class="top-content">
			<!--  -->
			<div class="nav-list">
				<template v-for="item in nav">
					<div class="nav-item" :key="item.name" v-if="item.name !== 'Home'">
						<div class="nav-label" @click="tabJump(item.url)">
							{{ item.title }}
						</div>
						<div class="nav-child">
							<div
								class="child-item"
								v-for="tab in item.tab"
								:key="tab.title"
								@click="tabJump(tab.url)"
							>
								{{ tab.title }}
							</div>
						</div>
					</div>
				</template>
			</div>
			<!--  -->
			<!--  -->
			<div class="other-right">
				<div class="label">咨询电话</div>
				<div class="phone">{{ contentr.phone }}</div>
				<div class="contact-information">
					<div class="contact-information-item" style="margin-right: 20px">
						<div class="label">客服二维码</div>
						<img class="wx-qrcode" src="@/assets/imgs/kfewm.png" alt="" />
					</div>
					<div class="contact-information-item">
						<div class="label">微信公众号</div>
						<img class="wx-qrcode" :src="contentr.wx_qrcode" alt="" />
					</div>
				</div>
			</div>
			<!--  -->
		</div>
		<!--  -->
		<div class="bottom-content">
			<div class="blogroll">
				<div class="blogroll-icon">友情链接</div>
				<div class="links">
					<div
						class="links-item"
						v-for="(item, index) in links"
						:key="index"
						@click="linksJump(item.url)"
					>
						{{ item.label }}
					</div>
				</div>
			</div>
			<div class="other">
				<div class="label">{{ contentr.address }}</div>
				<div class="beian" @click="jumpCopyright">
					<img class="icon" src="../assets/imgs/beian-icon.png" alt="" />
					{{ contentr.copyright }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { $getLogoContentr, $blogroll_link } from '@/api/index';
	import { NAV } from '@/constants.js';

	export default {
		name: 'Footer',
		data() {
			return {
				contentr: {},
			};
		},
		computed: {
			nav() {
				return NAV;
			},
			links() {
				return this.$store.getters.blogroll;
			},
		},
		watch: {},
		mounted() {
			$getLogoContentr()
				.then((response) => {
					// console.log(response);
					this.contentr = response.data;
				})
				.catch((res) => {
					// console.log(res);
				});
		},
		methods: {
			jumpCopyright() {
				window.location.href = 'https://beian.miit.gov.cn';
			},
			tabJump(url) {
				if (url.indexOf('https') !== -1) {
					window.location.href = url;
				} else {
					this.$router.push(url);
				}
			},
			linksJump(url) {
				window.open(url);
			},
		},
	};
</script>

<style scoped lang="scss">
	.footer {
		background: #0c0909;
		color: rgba(255, 255, 255, 0.7);

		.top-content {
			padding: 86px 10% 114px;
			margin: 0 auto;
			display: flex;
			justify-content: space-between;
			.nav-list {
				display: flex;
				line-height: 1;
				.nav-item {
					margin-right: 102px;
					&:last-of-type {
						margin-right: 0;
					}
					.nav-label {
						font-size: 16px;
						cursor: pointer;
					}
					.nav-child {
						margin-top: 37px;
						.child-item {
							font-size: 14px;
							margin-bottom: 19px;
							cursor: pointer;
						}
					}
					.nav-label:hover,
					.child-item:hover {
						color: #e60000;
					}
				}
			}
			.other-right {
				line-height: 1;
				.label {
					font-size: 14px;
					margin-bottom: 5px;
				}
				.phone {
					font-weight: bold;
					font-size: 16px;
					margin-bottom: 36px;
				}
				.contact-information {
					display: flex;
					align-items: center;
				}
				.wx-qrcode {
					width: 100px;
					height: 100px;
				}
			}
		}
		.bottom-content {
			border-top: 1px solid #1c1717;

			.blogroll {
				display: flex;
				align-items: center;
				padding: 31px 10%;
				.blogroll-icon {
					position: relative;
					width: 81px;
					height: 24px;
					background: #e60000;
					font-size: 14px;
					text-align: center;
					line-height: 24px;
					&::after {
						content: '';
						position: absolute;
						top: 50%;
						right: -5px;
						transform: translateY(-50%);
						width: 0;
						height: 0;
						border-top: 5px solid transparent;
						border-bottom: 5px solid transparent;
						border-left: 5px solid #e60000;
					}
				}
				.links {
					width: calc(100% - 81px);
					padding-left: 26px;
					display: flex;
					flex-wrap: wrap;

					.links-item {
						margin: 5px 41px 5px 0;
						font-size: 14px;
						cursor: pointer;
						&:hover {
							color: #e60000;
						}
					}
				}
			}
			.other {
				color: rgba(255, 255, 255, 0.3);
				font-size: 14px;
				padding: 15px 10% 31px;
				display: flex;
				flex-wrap: wrap;
				.label {
					margin-right: 55px;
					display: flex;
					align-items: center;
				}
				.beian {
					display: flex;
					align-items: center;
					cursor: pointer;
					&:hover {
						color: #e60000;
					}
				}
				.icon {
					width: 19px;
					height: 21px;
					margin-right: 10px;
				}
			}
		}
	}
</style>
